
//funguje pouze bez group cell, tj. co item to slide
export class FlickityAutoHeightExtension {
    constructor(flickity) {
        this.flickity = flickity
    }

    activate() {
        this.flickity.on('scroll', this.handleFlickityScroll)
        this.flickity.on('resize', this.handleResize)

        this.height = 0
        this.items = this.flickity.slides.map(slide => slide.cells[0].element)
        this.itemHeights = []
        this.itemPortion = 1 / (this.items.length - 1)
        this.roundedItemPortion = Math.round(this.itemPortion * 1000) / 1000
        this.resize()
    }

    deactivate() {
        this.flickity.off('scroll', this.handleFlickityScroll)
        this.flickity.off('resize', this.handleResize)
        this.flickity.viewport.style.transition = ''
        this.flickity.resize()
    }

    handleFlickityScroll = progress => {
        progress = Math.max(0, Math.min(1, progress))

        const modulo = progress % this.itemPortion
        let roundedModulo = Math.round(modulo * 1000) / 1000

        if (roundedModulo === this.roundedItemPortion) {
            roundedModulo = 0
        }

        const visibleIndex = Math.round(progress / this.itemPortion) //visibleIndex
        
        let height = 0

        if (roundedModulo) {
            if (roundedModulo < this.itemPortion / 2) {
                // console.log(`indexes: ${visibleIndex}/${visibleIndex+1}`)
                height = Math.max(this.itemHeights[visibleIndex], this.itemHeights[visibleIndex + 1])
            } else {
                // console.log(`indexes: ${visibleIndex-1}/${visibleIndex}`)
                height = Math.max(this.itemHeights[visibleIndex - 1], this.itemHeights[visibleIndex])
            }
        } else {
            // console.log(`index stable: ${visibleIndex}`)
            height = this.itemHeights[visibleIndex]
        }

        if (this.height === height) {
            return
        }

        this.height = height
        this.flickity.viewport.style.height = `${height}px`
        this.flickity.viewport.style.transition = '.1s height .05s ease' //az po prvnim nastaveni vysky pouzivat transition, aby se dobre vypocital scroll
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        this.itemHeights = this.items.map(item => item.offsetHeight)
    }


}